import React, { useState } from "react"
import styled from "styled-components"
import {
  hyphenDelimitedLowerCase,
  getContentTemplateData,
  generateFAQs,
  getLateNiteMerchants,
} from "../utils/functions"

import Layout from "../components/layout"
import CarouselWrapper from "../components/PhoenixWrappers/carousel"
import InternalLinkingBlock from "../components/internalLinkingBlock"
import InternalLinkingMerchant from "../components/internalLinkingMerchant"

import CategoryTileFilter from "../components/PhoenixWrappers/CategoryTileFilter"
import FlexCards from "../components/PhoenixWrappers/FlexCards"

import Autocomplete from "@airasia/phoenix-components/components/Autocomplete"
import ExpandableTextContainer from "@airasia/phoenix-widgets/widgets/ExpandableTextContainer"
import FAQ from "@airasia/phoenix-widgets/widgets/FAQ"
import Title from "@airasia/phoenix-components/components/Title"
import Text from "@airasia/phoenix-components/components/Text"

import { GTM_PROJECT_CATEGORY } from "../utils/constants"
import { Cities } from "../utils/homepageCarousel"
import { getGtmUserType, fireGtmEvent } from "../utils/functions"

const ContentWrapper = styled.div`
  margin-top: 2%;

  @media only screen and (max-width: 768px) {
    #pageTitle {
      font-size: 1.5rem;
    }

    #pageDescription {
      font-size: 0.9rem;
    }

    #autocomplete {
      font-size: 0.8rem;
    }
  }

  #airasia-product-tiles {
    position: initial;
  }
`

const MobileContainer = styled.div`
  @media only screen and (min-width: 768px) {
    display: none;
  }
`

const DesktopContainer = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`

const AutoCompleteWrapper = styled.div`
  margin-top: 2%;
  margin-bottom: 2%;
  width: 100%;
  @media only screen and (min-width: 768px) {
    width: 50%;
  }
`

const CityPage = props => {
  // console.log('Page Context', props.pageContext)
  const data = props.pageContext.mergedData || {}
  const type = "city"
  var location = props.pageContext.location
  const countryUrl = props.pageContext.countryUrl
  const url = props.pageContext.url
  let otherCitiesList = props.pageContext.nearbyLocation.map(city => {
    return {
      href: "/" + hyphenDelimitedLowerCase(city),
      label:
        countryUrl === "/th/th/"
          ? "อาหารเดลิเวอรี่ใน " + city
          : "Food Delivery in " + city,
    }
  })
  const countryName = props.pageContext.countryName
  const countryCode = props.pageContext.countryCode
  const isIntheList =
    countryUrl === "/"
      ? Cities["MY"].filter(fil => fil === location)
      : Cities[countryCode].filter(fil => fil === location)

  location = location
    ? location
        .toLowerCase()
        .split(" ")
        .map(s => s.charAt(0).toUpperCase() + s.substring(1))
        .join(" ")
    : location

  var carouselData = data ? data.categories : []
  carouselData = carouselData.concat(data.tags)
  // console.log(carouselData)

  const contentData = getContentTemplateData(location, countryUrl)

  // Categories for product tile component
  const foodCategories = props.pageContext.mergedData.categories.map(
    category => {
      return category.category
    }
  )

  const defaultCategory = foodCategories.length > 0 ? foodCategories[0] : ""

  // Label value pair for autocomplete tag search
  var autoCompleteItems = props.pageContext.mergedData.tags.map(tag => {
    return {
      label: tag.tag,
      value: tag.tag,
    }
  })

  // food type ENUM for filterCarouselData
  // the values must match that of the the mergedData in the page context
  const foodTypes = {
    category: "category",
    tag: "tag",
  }

  const filterCarouselData = (filterKey, type) => {
    return carouselData.filter(fil => fil[type] === filterKey)[0]
      ? carouselData.filter(fil => fil[type] === filterKey)[0].stores
      : []
  }

  const [selectedFoodCategory, setSelectedFoodCategory] = useState(
    defaultCategory
  )
  const [selectedFoodMerchants, setSelectedFoodMerchants] = useState(
    filterCarouselData(defaultCategory, foodTypes.category)
  )

  let defaultAutoCompleteLabel = "Wraps, Sushi or Bubble Tea? Search now!"

  // const generateContainerId = food => {
  //   return hyphenDelimitedLowerCase(food)
  // }

  const FAQ_DATA = generateFAQs(location, carouselData, countryUrl)
  const lateNiteMerchants = getLateNiteMerchants(carouselData)
  // console.log("lateNiteMerchants",lateNiteMerchants)
  otherCitiesList = otherCitiesList.filter(
    (v, i, a) =>
      a.findIndex(t => t.href === v.href && t.label === v.label) === i
  )
  const cityInternalLinking = [
    {
      description: "",
      link_objects: [...otherCitiesList],
      title:
        countryUrl === "/th/th/"
          ? `ลองแอร์เอเชียฟู๊ดในพื้นที่อื่นๆ`
          : `Try airasia food in other locations`,
    },
  ]
  // console.log("cityInternalLinking",cityInternalLinking)

  let lateNiteMerchantsData = lateNiteMerchants.map(store => {
    return {
      href: store.store.store_url,
      label: store.store.name,
    }
  })
  lateNiteMerchantsData = lateNiteMerchantsData.filter(
    (v, i, a) =>
      a.findIndex(t => t.href === v.href && t.label === v.label) === i
  )
  let internalLinkingTitle =
    countryUrl === "/th/th/"
      ? "หากยังคิดไม่ออกว่าจะทานอะไร ลองคลิกร้านอาหารใกล้คุณแล้วเลือกอาหารที่คุณชื่นชอบได้เลย"
      : `Not sure what to order? Check out these merchants nearby`
  const lateNiteMerchantInternalLinking = [
    {
      description: "",
      link_objects: [...lateNiteMerchantsData.slice(0, 8)],
      title: lateNiteMerchantsData.length ? internalLinkingTitle : "",
    },
  ]
  // console.log("countryUrl",countryUrl)
  let pageTitle = `Food Delivery in ${location}`
  let pageDescription = `Tasty food for everyone! Search for the cravings of your choice or
  quickly select a cuisine to order food from the best restaurants in ${location}`

  if (countryUrl === "/th/th/") {
    pageTitle = `อาหารเดลิเวอรี่ใน ${location}`
    pageDescription = `อาหารแสนอร่อยพร้อมเสิร์ฟสำหรับทุกคน! เลือกจานโปรดของคุณ หรือเลือกจากร้านอาหารที่ดีที่สุดใน ${location}`
    defaultAutoCompleteLabel = "ข้าว ก๋วยเตี๋ยว หรือว่าชาไข่มุกดีนะ? ค้นหาเลย!"
  }

  const [autoCompleteLabel, setAutoCompleteLabel] = useState(
    defaultAutoCompleteLabel
  )
  const [autoCompleteValue, setAutoCompleteValue] = useState()

  const handleTileClick = productId => {
    setSelectedFoodCategory(productId)
    setSelectedFoodMerchants(filterCarouselData(productId, foodTypes.category))
    setAutoCompleteValue()
    setAutoCompleteLabel(defaultAutoCompleteLabel)
  }

  return location ? (
    <Layout
      pageData={{
        heroBanner: [
          {
            altText: `${location} food delivery banner`,
            bannerID: `${location.replace(" ", "")}Page`,
            // buttonText: "Read more",
            buttonUrl: "",
            desktopImage: isIntheList.length
              ? "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/desktop/desktop_" +
                hyphenDelimitedLowerCase(location) +
                ".jpg"
              : "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food_Delivery_Generic_desktop.jpg",
            headline: "",
            mobileImage: isIntheList.length
              ? "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/mobile/mobile_" +
                hyphenDelimitedLowerCase(location) +
                ".jpg"
              : "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food_Delivery_Generic_mobile.jpg",
            redirectUrl: "https://www.airasia.com/food",
            showButton: false,
            subheadline: "",
            tabletImage: isIntheList.length
              ? "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/mobile/mobile_" +
                hyphenDelimitedLowerCase(location) +
                ".jpg"
              : "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food_Delivery_Generic_mobile.jpg",
          },
        ],
      }}
      url={url}
      location={location}
      type={type}
      countryUrl={countryUrl}
      countryName={countryName}
    >
      <ContentWrapper>
        <Title customProperties={{ id: "pageTitle" }} type="h1">
          {pageTitle}
        </Title>
        <Text customProperties={{ id: "pageDescription" }} type="medium">
          {pageDescription}
        </Text>
        <AutoCompleteWrapper>
          <Autocomplete
            customProperties={{ id: "autocomplete" }}
            items={autoCompleteItems}
            label={autoCompleteLabel}
            value={autoCompleteValue}
            onSelect={item => {
              setSelectedFoodMerchants(
                filterCarouselData(item.value, foodTypes.tag)
              )
              setAutoCompleteValue(item.value)

              const obj = {
                event: "trackEventNoEcommerce",
                "eventDetails.category": `${GTM_PROJECT_CATEGORY} | Autocomplete`,
                "eventDetails.action": `search`,
                "eventDetails.label": `${GTM_PROJECT_CATEGORY} | ${getGtmUserType()} | ${
                  item.value
                }`,
              }

              fireGtmEvent(obj)
            }}
            onClick={() => {
              setAutoCompleteLabel(
                countryUrl === "/th/th/" ? "กำลังหิวอยู่..." : "I am craving..."
              )

              const obj = {
                event: "trackEventNoEcommerce",
                "eventDetails.category": `${GTM_PROJECT_CATEGORY} | Autocomplete`,
                "eventDetails.action": `click`,
                "eventDetails.label": `${GTM_PROJECT_CATEGORY} | ${getGtmUserType()}`,
              }

              fireGtmEvent(obj)
            }}
          />
        </AutoCompleteWrapper>
        <DesktopContainer>
          <CategoryTileFilter
            categoryIds={foodCategories}
            highlightTileByDefaultId={defaultCategory}
            onTileClick={(_, productId) => handleTileClick(productId)}
            countryUrl={countryUrl}
          />
          {selectedFoodMerchants && (
            <ContentWrapper>
              <FlexCards
                title={selectedFoodCategory}
                cardData={selectedFoodMerchants}
              />
            </ContentWrapper>
          )}
        </DesktopContainer>
        <MobileContainer>
          <CategoryTileFilter
            device="mobile"
            categoryIds={foodCategories}
            highlightTileByDefaultId={defaultCategory}
            onTileClick={(_, productId) => handleTileClick(productId)}
            countryUrl={countryUrl}
          />
          {selectedFoodMerchants && (
            <ContentWrapper>
              <CarouselWrapper
                title={selectedFoodCategory}
                data={selectedFoodMerchants}
                countryUrl={countryUrl}
                lazyLoadImage={true}
                enableProgressiveImageLoading={false}
              />
            </ContentWrapper>
          )}
        </MobileContainer>
      </ContentWrapper>
      {lateNiteMerchantsData &&
        lateNiteMerchantInternalLinking.map(linking => {
          return (
            <ContentWrapper>
              <InternalLinkingMerchant
                linkObjects={linking.link_objects}
                blockTitle={linking.title}
                blockDescription={linking.description}
              />
            </ContentWrapper>
          )
        })}
      {cityInternalLinking &&
        cityInternalLinking.map(linking => {
          return (
            <ContentWrapper>
              <InternalLinkingBlock
                linkObjects={linking.link_objects}
                blockTitle={linking.title}
                blockDescription={linking.description}
              />
            </ContentWrapper>
          )
        })}
      <ContentWrapper>
        <ExpandableTextContainer
          data={contentData}
          dataSliceLimit={1}
          expandCtaText="Read more"
          compressCtaText="Read Less"
          ctaColor="secondary"
          ctaHoverColor="neutral"
          ctaHoverUnderlined
          ctaSize="normal"
          ctaUnderlined
          dataProperties={{
            compressCtaText: "Read less",
            ctaColor: "primary",
            ctaHoverColor: "neutral",
            ctaHoverUnderlined: true,
            ctaSize: "small",
            ctaUnderlined: false,
            expandCtaText: "Read more",
            sliceLimit: 350,
            textColor: "neutral",
            textType: "sub",
            titleColor: "neutral",
            titleMarginBottom: "normal",
            titleType: "h3",
          }}
        />
      </ContentWrapper>
      <ContentWrapper>
        <FAQ
          data={FAQ_DATA}
          title={countryUrl === "/th/th/" ? "คำถามที่พบบ่อย" : "FAQs"}
          titleMarginBottom="normal"
          titleType="h2"
        />
      </ContentWrapper>
    </Layout>
  ) : (
    <></>
  )
}
export default CityPage
